import React, { useEffect, useState } from 'react';
import { restaurantApi, RubricInfo } from '../services/api';

const CUISINE_TAG_OPTIONS = [
  'Европейская кухня', 'Японская кухня', 'Американская кухня', 'Итальянская кухня',
  'Русская кухня', 'Грузинская кухня', 'Паназиатская кухня', 'Азиатская кухня',
  'Авторская кухня', 'Армянская кухня', 'Белорусская кухня', 'Бурятская кухня',
  'Вегетарианская кухня', 'Восточная кухня', 'Кавказская кухня', 'Китайская кухня',
  'Корейская кухня', 'Мексиканская кухня', 'Немецкая кухня', 'Рыбная кухня',
  'Северная кухня', 'Сибирская кухня', 'Средиземноморская кухня', 'Турецкая кухня',
  'Якутская кухня',
];

const MENU_TAG_OPTIONS = [
  'Пицца', 'Бургеры', 'Суши', 'Стейки', 'Шашлык', 'Паста',
  'Шаурма', 'Хачапури', 'Рамен', 'Боулы', 'Хот-доги', 'Хинкали',
  'Лагман', 'Манты', 'На гриле', 'Плов', 'Салаты', 'Сэндвичи',
  'Том-Ям', 'Фалафель', 'Пицца на дровах',
];

const FEATURE_OPTIONS = [
  'Доставка', 'Бизнес-ланч', 'Wi-Fi', 'Детское меню', 'Завтраки', 'Можно с собакой',
];

const RATING_OPTIONS = [
  { label: '4.5+', value: 4.5 },
  { label: '4.0+', value: 4.0 },
  { label: '3.5+', value: 3.5 },
];

const INITIAL_TAGS_COUNT = 10;

// --- Icons ---
const CategoryIcon = () => (
  <svg className="w-3.5 h-3.5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="7" height="7" />
  </svg>
);

const ChefHatIcon = () => (
  <svg className="w-3.5 h-3.5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6z" /><line x1="6" y1="17" x2="18" y2="17" />
  </svg>
);

const MenuIcon = () => (
  <svg className="w-3.5 h-3.5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" /><path d="M7 2v20" /><path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3zm0 0v7" />
  </svg>
);

// Sparkles icon — подходит для "особенностей": что-то специальное, отличительное
const SparklesIcon = () => (
  <svg className="w-3.5 h-3.5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
    <path d="M5 3v4M19 17v4M3 5h4M17 19h4" />
  </svg>
);

const StarIcon = () => (
  <svg className="w-3.5 h-3.5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const ChainIcon = () => (
  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);

const LocationIcon: React.FC<{ active?: boolean }> = ({ active }) => (
  <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill={active ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" /><circle cx="12" cy="9" r="2.5" />
  </svg>
);

// --- Section header ---
const SectionHeader: React.FC<{ icon: React.ReactNode; label: string }> = ({ icon, label }) => (
  <div className="flex items-center gap-1.5 mb-1.5">
    {icon}
    <span className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider">{label}</span>
  </div>
);

// --- Chip button ---
const Chip: React.FC<{
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}> = ({ active, onClick, children }) => (
  <button
    onClick={onClick}
    className={`px-2.5 py-1 rounded-full text-xs font-medium transition-colors ${
      active
        ? 'bg-orange-500 text-white'
        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
    }`}
  >
    {children}
  </button>
);

// --- Filter state type ---
export interface FilterState {
  rubrics: string[];
  cuisineTags: string[];
  menuTags: string[];
  features: string[];
  minRating?: number;
  groupChains?: boolean;
  geoActive?: boolean;
  radius?: number;
}

export interface UnifiedFiltersProps {
  filters: FilterState;
  onChange: (filters: FilterState) => void;
  showChains?: boolean;
  showRating?: boolean;
  showGeo?: boolean;
  onGeoRequest?: () => void;
  geoAvailable?: boolean;
  citySlug?: string;
}

const UnifiedFilters: React.FC<UnifiedFiltersProps> = ({
  filters,
  onChange,
  showChains = false,
  showRating = true,
  showGeo = false,
  onGeoRequest,
  geoAvailable = true,
  citySlug,
}) => {
  const [rubrics, setRubrics] = useState<RubricInfo[]>([]);
  const [expandedCuisine, setExpandedCuisine] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(false);

  useEffect(() => {
    restaurantApi.getRubrics(citySlug).then((data) => {
      setRubrics(data.rubrics);
    }).catch(() => {});
  }, [citySlug]);

  // Auto-expand if active filters are hidden
  const activeCuisineHidden = filters.cuisineTags.some(t =>
    CUISINE_TAG_OPTIONS.indexOf(t) >= INITIAL_TAGS_COUNT
  );
  const activeMenuHidden = filters.menuTags.some(t =>
    MENU_TAG_OPTIONS.indexOf(t) >= INITIAL_TAGS_COUNT
  );

  const showAllCuisine = expandedCuisine || activeCuisineHidden;
  const showAllMenu = expandedMenu || activeMenuHidden;

  const visibleCuisine = showAllCuisine ? CUISINE_TAG_OPTIONS : CUISINE_TAG_OPTIONS.slice(0, INITIAL_TAGS_COUNT);
  const visibleMenu = showAllMenu ? MENU_TAG_OPTIONS : MENU_TAG_OPTIONS.slice(0, INITIAL_TAGS_COUNT);

  const toggle = <K extends keyof FilterState>(key: K, value: string) => {
    const arr = (filters[key] as string[]) || [];
    const updated = arr.includes(value) ? arr.filter(v => v !== value) : [...arr, value];
    onChange({ ...filters, [key]: updated });
  };

  const toggleRating = (value: number) => {
    onChange({ ...filters, minRating: filters.minRating === value ? undefined : value });
  };

  const radiusValue = filters.radius || 1000;

  // Sort rubrics by restaurantCount descending
  const sortedRubrics = [...rubrics].sort((a, b) => b.restaurantCount - a.restaurantCount);

  return (
    <div className="space-y-3">
      {/* Rubrics / Category */}
      <div>
        <SectionHeader icon={<CategoryIcon />} label="Категория" />
        <div className="flex flex-wrap gap-1.5">
          {sortedRubrics.map((r) => (
            <Chip key={r.id} active={filters.rubrics.includes(r.name)} onClick={() => toggle('rubrics', r.name)}>
              {r.name}
              <span className="ml-1 opacity-50">{r.restaurantCount}</span>
            </Chip>
          ))}
        </div>
      </div>

      {/* Cuisine tags */}
      <div>
        <SectionHeader icon={<ChefHatIcon />} label="Кухня" />
        <div className="flex flex-wrap gap-1.5">
          {visibleCuisine.map((tag) => (
            <Chip key={tag} active={filters.cuisineTags.includes(tag)} onClick={() => toggle('cuisineTags', tag)}>
              {tag.replace(' кухня', '')}
            </Chip>
          ))}
          {!showAllCuisine && CUISINE_TAG_OPTIONS.length > INITIAL_TAGS_COUNT && (
            <button
              onClick={() => setExpandedCuisine(true)}
              className="px-2.5 py-1 rounded-full text-xs font-medium text-gray-400 bg-gray-100 hover:bg-gray-200 transition-colors"
            >
              +{CUISINE_TAG_OPTIONS.length - INITIAL_TAGS_COUNT}
            </button>
          )}
          {showAllCuisine && !activeCuisineHidden && (
            <button
              onClick={() => setExpandedCuisine(false)}
              className="px-2.5 py-1 rounded-full text-xs font-medium text-gray-400 bg-gray-100 hover:bg-gray-200 transition-colors"
            >
              −
            </button>
          )}
        </div>
      </div>

      {/* Menu tags */}
      <div>
        <SectionHeader icon={<MenuIcon />} label="В меню" />
        <div className="flex flex-wrap gap-1.5">
          {visibleMenu.map((tag) => (
            <Chip key={tag} active={filters.menuTags.includes(tag)} onClick={() => toggle('menuTags', tag)}>
              {tag}
            </Chip>
          ))}
          {!showAllMenu && MENU_TAG_OPTIONS.length > INITIAL_TAGS_COUNT && (
            <button
              onClick={() => setExpandedMenu(true)}
              className="px-2.5 py-1 rounded-full text-xs font-medium text-gray-400 bg-gray-100 hover:bg-gray-200 transition-colors"
            >
              +{MENU_TAG_OPTIONS.length - INITIAL_TAGS_COUNT}
            </button>
          )}
          {showAllMenu && !activeMenuHidden && (
            <button
              onClick={() => setExpandedMenu(false)}
              className="px-2.5 py-1 rounded-full text-xs font-medium text-gray-400 bg-gray-100 hover:bg-gray-200 transition-colors"
            >
              −
            </button>
          )}
        </div>
      </div>

      {/* Features */}
      <div>
        <SectionHeader icon={<SparklesIcon />} label="Особенности" />
        <div className="flex flex-wrap gap-1.5">
          {FEATURE_OPTIONS.map((tag) => (
            <Chip key={tag} active={(filters.features || []).includes(tag)} onClick={() => toggle('features', tag)}>
              {tag}
            </Chip>
          ))}
        </div>
      </div>

      {/* Rating */}
      {showRating && (
        <div>
          <SectionHeader icon={<StarIcon />} label="Рейтинг" />
          <div className="flex items-center gap-1.5">
            {RATING_OPTIONS.map((opt) => (
              <Chip key={opt.value} active={filters.minRating === opt.value} onClick={() => toggleRating(opt.value)}>
                {opt.label}
              </Chip>
            ))}
          </div>
        </div>
      )}

      {/* Chains */}
      {showChains && (
        <div>
          <Chip active={!!filters.groupChains} onClick={() => onChange({ ...filters, groupChains: !filters.groupChains })}>
            <span className="flex items-center gap-1.5">
              <ChainIcon />
              Объединять сети
            </span>
          </Chip>
        </div>
      )}

      {/* Geolocation + Radius */}
      {showGeo && (
        <div className="space-y-2">
          <button
            onClick={onGeoRequest}
            disabled={!geoAvailable}
            className={`flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-medium transition-all w-full ${
              filters.geoActive
                ? 'bg-green-50 border border-green-200 text-green-700'
                : 'bg-gray-50 border border-gray-200 text-gray-600 hover:bg-gray-100'
            } ${!geoAvailable ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <LocationIcon active={filters.geoActive} />
            {filters.geoActive ? 'Геолокация включена' : 'Искать рядом со мной'}
          </button>

          {filters.geoActive && (
            <div className="px-1">
              <label className="block text-[11px] font-semibold text-gray-400 uppercase tracking-wider mb-1">
                Радиус: {radiusValue >= 1000 ? `${(radiusValue / 1000).toFixed(1)} км` : `${radiusValue} м`}
              </label>
              <input
                type="range"
                min={500}
                max={5000}
                step={100}
                value={radiusValue}
                onChange={(e) => onChange({ ...filters, radius: parseInt(e.target.value, 10) })}
                className="w-full accent-orange-500"
              />
              <div className="flex justify-between text-[10px] text-gray-400 mt-0.5">
                <span>500 м</span>
                <span>5 км</span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UnifiedFilters;
